module.exports = __webpack_public_path__ + "static/media/wtc_logo.b2e8cf39.svg";